// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TCSEligibilityStatus;
(function (TCSEligibilityStatus) {
    TCSEligibilityStatus[TCSEligibilityStatus["Unknown"] = -1] = "Unknown";
    TCSEligibilityStatus[TCSEligibilityStatus["PatientIneligible"] = 0] = "PatientIneligible";
    TCSEligibilityStatus[TCSEligibilityStatus["EligiblePending"] = 1] = "EligiblePending";
    TCSEligibilityStatus[TCSEligibilityStatus["PendingEnrollment"] = 2] = "PendingEnrollment";
    TCSEligibilityStatus[TCSEligibilityStatus["MemberNumberInvalid"] = 3] = "MemberNumberInvalid";
    TCSEligibilityStatus[TCSEligibilityStatus["ActivationPeriodExpired"] = 4] = "ActivationPeriodExpired";
    TCSEligibilityStatus[TCSEligibilityStatus["ReadyToActivate"] = 5] = "ReadyToActivate";
    TCSEligibilityStatus[TCSEligibilityStatus["TransferToTrialcard"] = 6] = "TransferToTrialcard";
})(TCSEligibilityStatus || (TCSEligibilityStatus = {}));
//# sourceMappingURL=tCSEligibilityStatus.js.map